declare global {
  interface Window {
    clarity?: (...args: any[]) => void;
  }
}

// Only set when this build's Dockerfile/workflow passes REACT_APP_CLARITY_PROJECT_ID as a
// build-arg — today that's staging only (see .github/workflows/deploy-test.yml). Production's
// deploy.yml never sets it, so initClarity() below no-ops there with zero code change needed
// to keep it off prod. Swapping in a production project ID later is just adding the same
// build-arg to deploy.yml — no logic to duplicate or branch on here.
const CLARITY_PROJECT_ID = process.env.REACT_APP_CLARITY_PROJECT_ID;

export function initClarity(): void {
  if (!CLARITY_PROJECT_ID || typeof window === 'undefined') return;
  if (window.clarity) return; // already initialized

  (function (c: any, l: Document, a: string, r: string, i: string) {
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
    const t = l.createElement(r) as HTMLScriptElement;
    t.async = true;
    t.src = 'https://www.clarity.ms/tag/' + i;
    const y = l.getElementsByTagName(r)[0];
    y.parentNode?.insertBefore(t, y);
  })(window, document, 'clarity', 'script', CLARITY_PROJECT_ID);
}

// Safe wrapper for every call site — never throws, whether the script hasn't finished
// loading yet, was blocked, or tracking is simply off (no project ID configured for this build).
export function trackEvent(eventName: string): void {
  try {
    if (typeof window !== 'undefined' && typeof window.clarity === 'function') {
      window.clarity('event', eventName);
    }
  } catch {
    // analytics must never break the app
  }
}
